import Backbone from 'backbone'

const TimesTableItemView = Backbone.View.extend({
    tagName: 'li',
    className: 'f3_menu_buttons',
    events: {
        'click': 'chooseTable',
    },
    initialize(options) {
        this.table = options.table
    },
    render() {
        this.$el.html(this.table)
        return this
    },
    chooseTable() {
        this.model.set({
            state: 'order',
            table: this.table
        })
    }
})

export default TimesTableItemView
